export const DocumentTitle = (title: string) => {
  document.title = title;
};
